import { keepPreviousData, queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';

import z from 'zod';
import { PayoutAccount, PayoutAccountStatus } from '@/types/api/payout-account';

export const ListPayoutAccountsParamsSchema = z
  .object({
    status: z.array(z.nativeEnum(PayoutAccountStatus)),
    groupId: z.string().nonempty(),
    userId: z.string().nonempty(),
  })
  .partial();

export type ListPayoutAccountsParams = z.infer<typeof ListPayoutAccountsParamsSchema>;

export const listPayoutAccounts = async (params: ListPayoutAccountsParams): Promise<PayoutAccount[]> => {
  return (await api.get(`/payments/payout-accounts`, { params })).data;
};

export const listPayoutAccountsQueryOptions = (params: ListPayoutAccountsParams = {}) => {
  return queryOptions({
    queryKey: Object.values(params).filter(Boolean).length ? ['payout-accounts', params] : ['payout-accounts'],
    queryFn: () => listPayoutAccounts(params),
    enabled: Boolean(params),
    placeholderData: keepPreviousData,
  });
};

type UsePayoutAccountsOptions = {
  queryConfig?: QueryConfig<typeof listPayoutAccountsQueryOptions>;
} & ListPayoutAccountsParams;

export const usePayoutAccounts = ({ queryConfig, ...params }: UsePayoutAccountsOptions) => {
  return useQuery({
    ...listPayoutAccountsQueryOptions(params),
    ...queryConfig,
  });
};

export const usePayoutAccountsSuspense = ({ queryConfig, ...params }: UsePayoutAccountsOptions) => {
  return useSuspenseQuery({
    ...listPayoutAccountsQueryOptions(params),
    ...queryConfig,
  });
};
